import { ITimeSource } from "@fe/core";
import { defaultTimeSource } from "./default-time-source";

export let timeSource = defaultTimeSource;

export function setTimeSource(source: ITimeSource) {
    timeSource = source;
}